import { FC } from "react";
import KickImage from 'Reuseables/KickImage';
import { toast } from 'react-toastify';

//Components
import CustomBody from "../CustomBody/index";
import { CustomButton } from "../../../Forms";

//Assets
import CopyIcon from "../../../../images/copy-icon.png";
import ScheduledIcon from "../../../../images/scheduled.png";
import PickupAddress from "../../../../images/pickup-address.png";

//Helper
import { CopyToClipboard } from "../../../../utils/Helpers";

//Interface
import { ComponentInterface } from "./definitions";

const Component: FC<ComponentInterface> = ({
  loading,
  order_id,
  address,
  suburb_name,
  city_name,
  province_name,
  postcode,
  renderDay,
  renderDate,
  renderMonth,
  renderHours,
  renderYear,
  onCancel,
  onPickupDetails,
  refreshHandler,
}) => {
  const CoppHandler = () => {
    CopyToClipboard(order_id)

    toast.success(
      "Copied",
      {
        position: 'top-right',
        autoClose: 1000,
        closeOnClick: true,
        pauseOnHover: true
      },
    );
  }
  return (
    <CustomBody loading={loading}>
      <div className="pickup-scheduled-details-body">
        <KickImage className="scheduled-icon" src={ScheduledIcon} alt="pickup-address" />
        <p className="title">Pick-up Scheduled</p>
        <p className="sub-title">The courier will arrive at the scheduled time and location.</p>
        <p className="refresh" onClick={refreshHandler}>Refresh</p>
        <div className="scheduled-details-wrapper">
          <div className="order-id-wrapper">
            <p className="order-text">Shipper Order ID</p>
            <p className="order-number">{order_id} <KickImage className="copy-icon" src={CopyIcon} alt="copy" onClick={CoppHandler} /></p>
          </div>

          <div className="scheduled-details-card">
            <KickImage className="pickup-address-icon" src={PickupAddress} alt="pickup-address" />
            <div className="scheduled-details-info">
              <p className="info-title">Pick-up Address</p>
              <p className="info-address">{address}, {suburb_name}, <br /> {city_name} {province_name}, {postcode}, Indonesia</p>
            </div>
          </div>

          <div className="scheduled-details-card no-border">
            <KickImage className="pickup-address-icon" src={ScheduledIcon} alt="pickup-address" />
            <div className="scheduled-details-info">
              <p className="info-title">Pick-up schedule</p>
              <div className="scheduled-date">
                <span>{renderDay}, {renderDate} {renderMonth} {renderYear}</span>
                {renderHours}
              </div>
            </div>
          </div>

        </div>

        <div className="button-wrapper">
          <CustomButton
            className="cancel-btn"
            text={"Cancel"}
            disabled={false}
            onClick={() => onCancel()}
          />
          <CustomButton
            text={"Pick-up details"}
            disabled={false}
            onClick={() => onPickupDetails()}
          />
        </div>
      </div>
    </CustomBody>
  )
}

export default Component;